import styled from 'styled-components'
import CoolFont from './8-bit-pusab.ttf'

export const Button = styled.button`
  @font-face {
    font-family: '8 bit pusab';
    src: url(${CoolFont}) format('truetype');
  }
  background-color: #6332cc;
  border: none;
  border-radius: 8px;
  display: flex;
  font-family: '8 bit pusab';
  font-size: 10px;
  outline: none;
  padding: 10px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: auto;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin: auto;
  `}
`

export const LeftSideWrapper = styled.div`
  margin-bottom: 36px;
  margin-left: 36px;
  margin-top: 16px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    text-align: center;
    width:100%;
    margin-left: 0;
    margin:auto;
    padding-top: 20px;
  `};
  ${({ theme }) => theme.mediaWidth.upToLarge`
    text-align: center;
    width:100%;
    margin-left: 0;
    margin:auto;
    padding-top: 20px;
  `};
`

export const CoolStuff = styled.div`
  font-size: 30px;
  font-weight: bold;
  padding-top: 24px;
  margin: 0 12px;
`

export const PleaseVisit = styled.div`
  font-size: 14px;
  font-weight: 400;
  padding-top: 20px;
  margin: 0 12px;
`

export const ResponsiveFlex = styled.div`
  background-color: #814eed;
  border: none;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  &:hover {
    .click-me {
      transform: scale(1.5) translateX(-40px) translateY(-16px);
    }
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    flex-direction: column;
  `}
`

export const ResponsiveBoxyCatWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0;
  padding: 0;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    justify-content: column;
  `}
`
export const AbsoluteImg = styled.img`
  position: absolute;
  top: 22%;
  width: 48%;
  z-index: 1;
  left: -20%;
  transition: transform 0.15s ease-in-out;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    left: 0%;
    top: 16%;
    max-width: 30%;
  `}
  ${({ theme }) => theme.mediaWidth.upToLarge`
    left: 0%;
    top: 16%;
    max-width: 30%;
  `}
`

export const ResponsiveBoxyCatImg = styled.img`
  display: block;
  height: auto;
  image-rendering: pixelated;
  margin-top: 80px;
  width: 48vmin;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: auto;
    margin-top: 16px;
    width: 90vmin;
  `};
  ${({ theme }) => theme.mediaWidth.upToLarge`
    height: auto;
    margin-top: 16px;
    width: 80vmin;
  `};
`
